// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"c6308a80","489":"bca07bbb","690":"b54ef081","855":"a78b3689","987":"960b9480"}[chunkId] + ".css";
};